/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/layout'

const systemManageRouter = {
  path: '/systemManage',
  component: Layout,
  hidden: false,
  redirect: 'noredirect',
  name: 'SystemManage',
  meta: {
    title: '系统管理',
    icon: 'system',
    roles: ['admin']
  },
  children: [
    {
      path: 'modifyPassword',
      component: resolve => require(['@/views/common/resetPassword'], resolve),
      name: 'modifyPassword',
      meta: { title: '修改密码', noCache: true, noKeepAlive: true }
    },
    {
      path: 'operationLog',
      component: resolve => require(['@/views/manage/systemManage/operationLog'], resolve),
      name: 'OperationLog',
      meta: { title: '操作日志', noCache: false }
    },
    {
      path: 'loginLog',
      component: resolve => require(['@/views/manage/systemManage/loginLog'], resolve),
      name: 'LoginLog',
      meta: { title: '登录日志', noCache: false }
    },
    {
      path: 'tradingSwitch',
      component: resolve => require(['@/views/manage/systemManage/tradingSwitch'], resolve),
      name: 'TradingSwitch',
      meta: { title: '交易开关', noCache: false }
    },
    {
      path: 'systemDeploy',
      component: resolve => require(['@/views/manage/systemManage/systemDeploy'], resolve),
      name: 'SystemDeploy',
      meta: { title: '系统配置', noCache: false }
    },
    {
      path: 'ipManage',
      component: resolve => require(['@/views/manage/systemManage/ipManage'], resolve),
      name: 'IPManage',
      meta: { title: 'IP管理', noCache: false }
    },
    // {
    //   path: 'noticeManage',
    //   component: resolve => require(['@/views/manage/systemManage/noticeManage'], resolve),
    //   name: 'NoticeManage',
    //   meta: { title: '公告管理', noCache: false }
    // },
    {
      path: 'bank',
      component: resolve => require(['@/views/manage/systemManage/bankManage'], resolve),
      name: 'Bank',
      meta: { title: '银行管理', noCache: false }
    },
    {
      path: 'withdrawBlacklist',
      component: resolve => require(['@/views/manage/financeManage/withdrawBlacklist'], resolve),
      name: 'WithdrawBlacklist',
      meta: { title: '黑名单银行卡管理', noCache: false }
    },//2023-06-28移到系统管理
    {
      path: 'blacklistname',
      component: resolve => require(['@/views/manage/financeManage/blacklistname'], resolve),
      name: 'Blacklistname',
      meta: { title: '黑名单姓名管理', noCache: false }
    },//2023-06-28移到系统管理
    {
      path: 'blacklistIDcard',
      component: resolve => require(['@/views/manage/financeManage/blacklistIDcard'], resolve),
      name: 'BlacklistIDcard',
      meta: { title: '黑名单身份证管理', noCache: false }
    },
    {
      path: 'platrobotConfig',
      component: resolve => require(['@/views/manage/systemManage/platrobotConfig'], resolve),
      name: 'PlatrobotConfig',
      meta: { title: '平台机器人配置', noCache: false }
    },
    {
      path: 'riskConfig',
      component: resolve => require(['@/views/manage/systemManage/riskConfig'], resolve),
      name: 'RiskConfig',
      meta: { title: '风控配置', noCache: false }
    },
  ]
}

export default systemManageRouter



// WEBPACK FOOTER //
// ./src/router/manage/systemManage.js